module.exports = __webpack_public_path__ + "img/icon-propagation.52e3d270.svg";